import { z } from 'zod';
import { defineFeature } from '../core/defineFeature.js';
import { FeatureType } from '../core/types.js';
const WorkspaceFunctionality = { id: 4, name: 'Workspace Functionality' };
export const workspaces = defineFeature({
    type: FeatureType.Boolean,
    propName: 'workspaces',
    uiName: 'workspaces',
    displayName: 'Workspaces',
    description: 'Enable workspace functionality',
    category: WorkspaceFunctionality,
    areas: ['agent'],
    codec: 'identity',
    schema: z.boolean(),
    default: false,
    isSystem: true,
});
export const workspaceBrands = defineFeature({
    type: FeatureType.Boolean,
    propName: 'workspace_brands',
    uiName: 'workspaceBrands',
    displayName: 'Workspace Brands',
    description: 'Enable/Disable Brands in workspace',
    category: WorkspaceFunctionality,
    areas: ['agent'],
    codec: 'identity',
    schema: z.boolean(),
    default: false,
    isSystem: true,
});
export const autoTagFiles = defineFeature({
    type: FeatureType.Boolean,
    propName: 'auto_tag_files',
    uiName: 'autoTagFiles',
    displayName: 'Auto Tag Files',
    description: 'Automatically generate tags for files',
    category: WorkspaceFunctionality,
    areas: ['agent'],
    codec: 'identity',
    schema: z.boolean(),
    default: true,
    isSystem: true,
});
export const workspaceFunctionalityFeatures = [
    workspaces,
    workspaceBrands,
    autoTagFiles,
];
